export const DOC_TRADE_USER_API_FETCH = 'docTradeUserApi/FETCH';
export const DOC_TRADE_USER_API_DATA = 'docTradeUserApi/DATA';
export const DOC_TRADE_USER_API_ERROR = 'docTradeUserApi/ERROR';
